import React from 'react';
import { createIcon } from './create-icon';
import './icon-search.scss';

export const IconSearch = createIcon(<div className="icon-search" />);
